export enum EPackageServiceType {
  /** Топ 3 */
  Top = 'top3',
  /** Премиум */
  Premium = 'premiumObject',
  /** Платное размещение */
  Paid = 'debitObject',
  /** Аукцион */
  Auction = 'auction',
  /** Стандарт */
  Standard = 'standard',
}
